import { UsageLeagueDimensionDefinition } from "../../types/analytics/UsageLeagueDto";

export const usageLeagueDimensions: UsageLeagueDimensionDefinition[] = [
  {
    key: "LOCATION",
    label: {
      translationKey: "Analytics.Widgets.Usage.League.Dimension.Location",
      defaultValue: "Location",
    },
    hierarchical: true,
    source: "LOCATION_HIERARCHY",
  },
  {
    key: "JOB_LEVEL",
    label: {
      translationKey: "Analytics.Widgets.Usage.League.Dimension.JobLevel",
      defaultValue: "Job level",
    },
    hierarchical: false,
    source: "APPRAISAL_LEVEL",
  },
];
